export default {
  computed: {
    isSafariCheck() {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator?.userAgent);
      return isSafari;
    },
  },
};
